module.exports = __webpack_public_path__ + "static/media/1.b83ad2d1.png";